import React, { useState } from 'react';
import Select, { components } from 'react-select';
import { FlagIcon } from 'react-flag-kit';
import 'react-flag-kit/dist/index.cjs';
import { getAnalytics, logEvent } from "firebase/analytics";
import i18n from "i18next";
import queryString from 'query-string';
import ReactModal from 'react-modal';

const modalContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%', // Ensure the modal content takes the full height
  background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(44,67,80,1) 35%, rgba(44,67,80,1) 100%)', // Add the background style
};
const boldTextStyle = {
  fontWeight: 'bold',
  fontSize: '24px', // Adjust the font size as needed
  color: 'whitesmoke', // Adjust the text color as needed
};
const speechStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

const languageOptions = [
  { value: 'fr', label: 'Français', icon: 'FR' },
  { value: 'en', label: 'English', icon: 'GB' },
    { value: 'sn', label: 'Wolof', icon: 'SN' },
  /*{ value: 'es', label: 'Español', icon: 'ES' },*/
  { value: 'zh', label: '中文', icon: 'CN' }, // Add Chinese option
];

const Option = (props) => (
  <components.Option {...props}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <FlagIcon code={props.data.icon} />
      <div style={{ marginLeft: '8px' }}>{props.data.label}</div>
    </div>
  </components.Option>
);

function LogChange(lang) {
  logEvent(getAnalytics(), 'change_language', {
    content_type: 'lang',
    content_id: lang  
  });
}


const SingleValue = (props) => (
  <components.SingleValue {...props}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <FlagIcon code={props.data.icon} />
      <div style={{ marginLeft: '8px' }}>{props.data.label}</div>
    </div>
  </components.SingleValue>
);

class LanguageSelector extends React.Component {

  constructor(props) {
    super(props);

    // Parse query parameters and get the 'lang' parameter
    const queryParams = queryString.parse(window.location.search);
    const selectedLang = queryParams.lang || languageOptions[0].value;
    // Check if the selected language is in the languageOptions array, otherwise, use a default value
    const selectedLanguage = languageOptions.find(option => option.value === selectedLang) || languageOptions[0];

    this.state = {
      selectedLanguage,
      showModal: false // Add state variable for the modal
    };
 }

  handleOpenModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({
       selectedLanguage: languageOptions[0],
       showModal: false
      }
    );
  };

  handleChange = (selectedOption) => {
    if (selectedOption.value === 'zh') {
      // Open the modal
      this.handleOpenModal();
      return;
    }

    i18n.changeLanguage(selectedOption.value);
    LogChange(selectedOption.value);
    this.setState({ selectedLanguage: selectedOption });
  };


  componentDidUpdate(prevProps, prevState) {
    // Check if the showModal state has changed and reset the defaultValue
    if (prevState.showModal !== this.state.showModal) {
      this.setState({ selectedLanguage: languageOptions[0] });
    }
  }

  render() {
    const { selectedLanguage, showModal } = this.state;

    return (
      <div>
        <Select
          key={showModal ? 'modal' : 'default'} // Use a key that changes when showModal changes
          defaultValue={selectedLanguage}
          name="language"
          options={languageOptions}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={this.handleChange}
          isSearchable={false}
          styles={{
            option: (base, state) => ({
              ...base,
              color: state.isSelected ? 'white' : 'black',
              backgroundColor: state.isSelected ? 'black' : 'white',
            }),
          }}
          components={{
            Option: Option,
            SingleValue: SingleValue,
          }}
        />
        {/* Conditional rendering for the modal */}
        <ReactModal
            isOpen={showModal}
            onRequestClose={this.handleCloseModal}
          >
          <div style={modalContentStyle}>
            <div style={boldTextStyle}>
              <div>Still don't speak Chinese :p</div>
              <div style={speechStyle}>xièxiè</div>
            </div>
            <button onClick={this.handleCloseModal}>Close</button>
          </div>
        </ReactModal>
      </div>
    );
  }
}

export default LanguageSelector;
